import { MatTableDataSource } from '@angular/material/table';
import { ScBaseTableViewConfig, ScEndpointFilter, ScTableActionSelection } from '../../../models/table.model';

export class InitView {
  static readonly type = '[View] InitView';
  constructor(public instanceId: string, public config: ScBaseTableViewConfig, public datasource: MatTableDataSource<any>) {}
}

export class SetData {
  static readonly type = '[View] SetData';
  constructor(public instanceId: string, public data: any[]) {}
}

export class SetLoading {
  static readonly type = '[View] SetLoading';
  constructor(public instanceId: string, public loading: boolean) {}
}

export class ToggleSelection {
  static readonly type = '[View] ToggleSelection';
  constructor(public instanceId: string, public data: any[]) {}
}

export class LoadData {
  static readonly type = '[View] LoadData';
  constructor(
    public instanceId: string,
    public page: number = 0,
    public pageSize: number = 0,
    public filters: ScEndpointFilter[] = [],
    public advancedFilters: ScEndpointFilter[] = [],
    public sortProp = 'Tstamp',
    public direction: 'asc' | 'desc' = 'desc'
  ) {}
}

export class EntityAction {
  static readonly type = '[View] EntityAction';
  constructor(public instanceId: string, public action: ScTableActionSelection) {}
}

export class AddEntity {
  static readonly type = '[View] AddEntity';
  constructor(public instanceId: string, public row: any) {}
}

export class UpdateEntity {
  static readonly type = '[View] UpdateEntity';
  constructor(public instanceId: string, public row: any) {}
}

export class DeleteEntity {
  static readonly type = '[View] DeleteEntity';
  constructor(public instanceId: string, public row: any) {}
}
